import { render, staticRenderFns } from "./recordings.vue?vue&type=template&id=6420c5c9&"
import script from "./recordings.vue?vue&type=script&lang=js&"
export * from "./recordings.vue?vue&type=script&lang=js&"
import style0 from "./recordings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports